import { useToast } from '@shared/components/toast';
import { useCreateInstantQuoteMutation } from '@shared/generated/graphql';

export const useCreateEmptyQuote = () => {
  const { sendToast } = useToast();
  const [createInstantQuote, { loading }] = useCreateInstantQuoteMutation();

  const createEmptyQuote = async () => {
    if (loading) return;

    const quoteRes = await createInstantQuote();
    const quote = quoteRes.data?.createInstantQuote.quote;
    if (!quote) {
      sendToast('Failed to create quote', { variant: 'error' });
      return;
    }

    return { id: quote.id };
  };

  return {
    createEmptyQuote,
    loading,
  };
};
